import * as React from 'react';
import StandardSummaryLegend from '../StandardSummaryLegend';
import { sortBasedOnList } from '../utils';

export type Table1Data = { [key: string]: Table1Row }
export type Table1Row = {
  crashesTotal: number;
  crashesFatal: number;
  nonFatalCrashesTotal: number;
  nonFatalCrashesInjuryA: number;
  nonFatalCrashesInjuryB: number;
  nonFatalCrashesInjuryC: number;
  crashesPdo: number;
  personsFatal: number;
  personsNonFatalTotal: number;
  personsInjuryA: number;
  personsInjuryB: number;
  personsInjuryC: number;
}

export interface ITable1ClassProps {
  data: Table1Data;
}

interface ITable1State {
}

const initialState: ITable1State = {
};

const sortOrder = [
  "Pedestrian",
  "Motor vehicle in transport",
  "Parked motor vehicle",
  "Railroad train",
  "Pedalcyclist",
  "Animal",
  "Fixed object",
  "Other object",
  "Non-collision overturned",
  "Other non-collision",
  "Unknown",
  "TOTALS",
]

export default class Table1 extends React.Component<ITable1ClassProps, ITable1State> {
  public constructor(props: any) {
    super(props);
    this.state = initialState;
  };

  componentDidMount = () => {
    // get data
  }

  public render() {
    return (
      <div style={{ display: 'flex', marginLeft: -68 }}>
        {!this.props.data && (
          <p>Loading....</p>
        )}
        {this.props.data && (
          <table className="ss-table summaryTable1" style={{ width: 900 }}>
            <thead>
              <tr>
                <th rowSpan={3} colSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">1</span>
                    <span className="header-text" style={{ fontSize: '14px' }}>
                      FIRST HARMFUL EVENT
                      <br />
                      <span style={{ fontSize: '13px' }}>(CURRENT YEAR)</span>
                    </span>
                  </div>
                </th>
                <th colSpan={7} className="border-right-bold">CRASHES</th>
                <th colSpan={5} className="border-right-bold">PERSONS KILLED OR INJURED</th>
              </tr>
              <tr>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={4}>NON-FATAL INJURY CRASHES</th>
                <th rowSpan={2} className="border-right-bold">PDO **</th>
                <th rowSpan={2}>KILLED</th>
                <th colSpan={4}>NON-FATAL INJURIES</th>
              </tr>
              <tr>
                <th>TOTAL</th>
                <th>A *</th>
                <th>B * </th>
                <th>C * </th>
                <th>TOTAL</th>
                <th>A *</th>
                <th>B * </th>
                <th>C * </th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key, index) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  {index === 0 &&
                    <td rowSpan={8}><p className="verticalColumn" style={{ width: 17, left: 0 }}>Collision Involving</p></td>
                  }
                  <td colSpan={index > 7 ? 2 : 1} className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].crashesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].crashesFatal}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesTotal}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryB}</td>
                  <td className="numberTotals">{this.props.data[key].nonFatalCrashesInjuryC}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key].crashesPdo}</td>
                  <td className="numberTotals">{this.props.data[key].personsFatal}</td>
                  <td className="numberTotals">{this.props.data[key].personsNonFatalTotal}</td>
                  <td className="numberTotals">{this.props.data[key].personsInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key].personsInjuryB}</td>
                  <td className="numberTotals">{this.props.data[key].personsInjuryC}</td>
                </tr>
              )}
            </tbody>
          </table >
        )
        }
        <StandardSummaryLegend />
      </div >
    );
  }
}
